/*
 * Ostrzeżenie przed nawigacją w obrębie samej aplikacji, gdy są niezapisane
 * zmiany (np. w edytorze odpowiedzi prawnika).
 *
 * Router w tej apce to zwykły <BrowserRouter> (nie "data router"), więc
 * useBlocker z react-router-dom tu nie zadziała — wymaga RouterProvider,
 * a przejście na niego to spora, ryzykowna przebudowa całego routingu.
 * Zamiast tego: jeden globalny nasłuch kliknięć w fazie capture, na poziomie
 * całego dokumentu — łapie każdy link (Link z react-router renderuje się
 * jako zwykłe <a>), niezależnie od tego, w którym komponencie jest kliknięty,
 * bez dotykania pojedynczych <Link> w kodzie.
 *
 * Świadomie NIE obsługuje przycisku wstecz/dalej przeglądarki (popstate) —
 * cofnięcie tego w locie wymagałoby manipulacji historią i jest źródłem
 * własnych błędów. To ostrzega przed kliknięciem linku, nie przed każdym
 * możliwym sposobem opuszczenia strony w obrębie aplikacji.
 */

let dirty = false;
let message = 'Masz niezapisane zmiany. Czy na pewno chcesz opuścić tę stronę?';

/** Wywoływane przez stronę, która ma coś do stracenia (np. edytor odpowiedzi). */
export function setUnsavedGuard(isDirty, customMessage) {
  dirty = Boolean(isDirty);
  if (customMessage) message = customMessage;
}

let installed = false;

/** Wołane raz, przy starcie aplikacji. */
export function installUnsavedGuard() {
  if (installed) return;
  installed = true;

  document.addEventListener(
    'click',
    (e) => {
      if (!dirty) return;
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      const a = e.target.closest('a');
      if (!a || !a.href) return;
      if (a.target === '_blank') return; // nowa karta — bieżąca strona zostaje otwarta

      let url;
      try {
        url = new URL(a.href, window.location.href);
      } catch {
        return;
      }
      if (url.origin !== window.location.origin) return; // link zewnętrzny

      if (!window.confirm(message)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true // faza capture — zanim React Router obsłuży kliknięcie
  );
}
